exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".band{position:relative;padding:10px;border-radius:3px;height:200px;border:1px solid #dcdfe6;margin-left:10px;text-align:center}.Saat{font-weight:700;font-size:20px;color:#8996a0}.el-carousel__item a{color:#8996a0;font-size:12px;opacity:1;margin:0;line-height:10px;font-weight:500;text-align:left}.el-carousel__indicators--vertical{display:none!important}.haber{color:#333;font-size:10px;border:1px solid #dcdfe6;border-radius:3px;padding:5px;margin-top:5px;position:relative;text-align:left}.haber img{width:15px;position:absolute;right:5px;bottom:5px;opacity:.3}.haber .el-carousel{margin-top:2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-02bc93f0","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Pack/Panel/PanelBand.vue
// module id = 606
// module chunks = 0